import { render, staticRenderFns } from "./promotionAward.vue?vue&type=template&id=8e9e7c16&scoped=true&"
import script from "./promotionAward.vue?vue&type=script&lang=js&"
export * from "./promotionAward.vue?vue&type=script&lang=js&"
import style0 from "./promotionAward.vue?vue&type=style&index=0&id=8e9e7c16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9e7c16",
  null
  
)

export default component.exports